import styles from './Input.module.scss';

interface TextareaProps extends React.HTMLAttributes<HTMLTextAreaElement> {
  id: string;
  value: string | number;
  setValue: (val: string) => void;
  label: string;
  placeholder?: string;
}

const Textarea = ({ label, value, id, placeholder, setValue, ...rest }: TextareaProps) => {
  return (
    <>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>

      <textarea
        {...rest}
        className={styles.input}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        {...{ id, placeholder }}
        name={id}
        rows={8}
      />
    </>
  );
};

export default Textarea;
